export default {
  back: 'Tilbage til menuen',
  menu: 'Menu',
};
